import { fetchPageMetaData } from "../../fetch/graphql/page";
import log from "../../utils/logger/library";
import * as pathUtils from "../../utils/path/library";
import { DEFAULT_PAGE_DESCRIPTION } from "../App/constants";
import { set_loading_complete } from "../Loader/dispatchers";
import { start_loading } from "../../reducers/Loader/reducer";
import { update_tracking } from "../../reducers/Tracking/reducer";
import { buildTracking, populateTrackingObject } from "./utils";

export const fetch_tracking = (pageData = {}, fetchLanding = true) => {
    return async (dispatch, getState) => {
        const state = getState();
        const { app } = state;
        const trackingObject = populateTrackingObject(app, pageData.section);

        if (fetchLanding) {
            await dispatch(fetch_page_tracking_graphql(app.path));
        } else {
            const tracking = buildTracking({
                id: app.path,
                title: pageData.title || app.title,
                tracking: trackingObject?.tracking,
                attribution: pageData.section?.attributionLevels,
                pageType: app.pageType,
                description: pageData.metadata?.description || "",
            });
            await dispatch(update_tracking(tracking));
        }
    };
};

export const fetch_page_tracking_graphql = (nextPath) => {
    return async (dispatch, getState) => {
        try {
            const state = getState();
            const { path, pageType, baseSection, subSection } = state.app;

            dispatch(start_loading());

            const { page } = await fetchPageMetaData(
                `path:"${nextPath ? nextPath : path}"`
            );
            const defaultDescription = `CBC ${baseSection || ""} ${
                subSection || ""
            } - ${DEFAULT_PAGE_DESCRIPTION}`;

            const title = page.title || pathUtils.formatMetaTitle(state.app);
            const description =
                page?.metadata?.description || defaultDescription;

            if (page.section?.tracking) {
                page.section.tracking.contenttype = "index";
            }

            const tracking = buildTracking({
                id: page.path,
                title,
                description,
                tracking: page.section?.tracking,
                attribution: page.section?.attributionLevels,
                pageType,
            });
            dispatch(update_tracking(tracking));
        } catch (error) {
            log.error(
                `(fetch_page_tracking_graphql) Request failed for path ${nextPath}`,
                error
            );
        } finally {
            dispatch(set_loading_complete());
        }
    };
};
